exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn--activity-registrations[data-v-593e9004] {\n  margin-left: 2rem;\n}", ""]);

// exports
